export { default as Arrows } from './Arrows';
export { default as FadeInSlider } from './FadeInSlider';
export { default as Footer } from './Footer';
export { default as Header } from './Header';
export { default as Loading } from './Loading';
export { default as Navigation } from './Navigation';
export { default as SliderElement } from './SliderElement';
